
'use client';

import { variants, variants2 } from '@/components/transitions/QuestionTransitionEffect';
import { motion } from 'framer-motion';
import useGeneralStore from '@/store/general';
import { useEffect, useState } from 'react';
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";
import { usePathname } from 'next/navigation';
import { DateTime } from 'luxon';


export default function Template({ children }: { children: React.ReactNode }) {
    const { isMobile } = useGeneralStore();



    // const [pathFromNavigation, setPathFromNavigation] = useState('');
    // const [extractedPath, setExtractedPath] = useState('');

    // Choose the appropriate variant based on screen size
    const selectedVariants = isMobile ? variants2 : variants;

    // const pathname = usePathname();

    // useEffect(() => {
    //     setPathFromNavigation(pathname);
    // }, [pathname])
    // useEffect(() => {
    //     setExtractedPath(pathFromNavigation.replace(/^\/(steps)\//, ''));
    // }, [pathFromNavigation])


    // useEffect(() => {
    //     console.log('---------------------------key---------------------------');
    //     console.log(pathname);

    //     initializeAnalitics()
    // }, [])




    // const [analytics, setAnalytics] = useState<any>(null);


    // const initializeAnalitics = async () => {
    //     if (await isSupported()) {
    //         setAnalytics(getAnalytics(firebaseApp))
    //     }
    // }

    // useEffect(() => {
    //     analytics && logEvent(analytics, 'steps', {
    //         landing_datetime: DateTime.now(),
    //         step: extractedPath
    //     })
    // }, [analytics])


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <motion.div
            initial="hidden"
            animate="enter"
            // key={key}
            exit="exit"
            variants={selectedVariants} >
            {children}
        </motion.div>
    );
}
